import ResourceModal from 'app/components/ResourceModal';
import JobConfigTemplateForm from './JobConfigTemplateForm';

const JobConfigTemplateModal = props => {
  const {
    isOpen,
    onClose,
    onFormSubmit,
    jobConfigTemplate
  } = props;

  const action = jobConfigTemplate ? 'update' : 'create';
  const title = jobConfigTemplate ? `Edit ${jobConfigTemplate.name}` : 'Create Product';
  const onSubmit = params => onFormSubmit(action, params);

  return (
    <ResourceModal {...{ isOpen, onClose, title }}>
      <JobConfigTemplateForm {...{ jobConfigTemplate, action, onClose, onSubmit }} />
    </ResourceModal>
  );
}

export default JobConfigTemplateModal;
